import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from '../../components/SubNavBar/SubNavBar';
import CommunityDiscount from './CommunityDiscount';

function action({ store }) {
  const title = store.getState().siteSettings?.data?.siteTitle;
  const description = store.getState().siteSettings?.data?.metaDescription;
  const isAuthenticated = store.getState().runtime.isAuthenticated;

  // Public marketing page: anyone can read the program + how to qualify; only
  // applying needs an account (we prompt login in-page). Never dead-ends.
  return {
    title,
    description,
    component: (
      <Layout>
        <div className="subPageMainContainer">
          {isAuthenticated && <SubNavBar />}
          <CommunityDiscount isAuthenticated={isAuthenticated} />
        </div>
      </Layout>
    ),
  };
}

export default action;
